import { render, staticRenderFns } from "./ProductsSalePriceMarginList.vue?vue&type=template&id=2acd820b&lang=pug&"
import script from "./ProductsSalePriceMarginList.vue?vue&type=script&lang=js&"
export * from "./ProductsSalePriceMarginList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductsSalePriceMarginList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VSelect,
  VToolbar,
})
